import firebase from 'firebase'

const config = {
	// //dev
	// apiKey: "AIzaSyD4uHMDMoQ4BRQSPzAI8O3wVv7XJwJvT0Q",
	// authDomain: "eureka2-dev.firebaseapp.com",
	// databaseURL: "https://eureka2-dev.firebaseio.com",
	// projectId: "eureka2-dev",
	// storageBucket: "eureka2-dev.appspot.com",
	// messagingSenderId: "668932300553"

	//prod
	apiKey: "AIzaSyCVLa_Rim8fvujeoKzdmmboB9Tyth0q6vw",
	authDomain: "keepeurekastrong.firebaseapp.com",
	databaseURL: "https://keepeurekastrong.firebaseio.com",
	projectId: "keepeurekastrong",
	storageBucket: "",
	messagingSenderId: "452557045561"
}

//dev
// export const kesAdmin = "iFiAfQ8AP8eHtAOAnvIyiXyfRbI2"
// prod
export const kesAdmin = "pozmQvzyG3U3EFkJ62EJWTWK8GI2"

firebase.initializeApp(config)

export const provider = new firebase.auth.GoogleAuthProvider()
export const db = firebase.database()
export const auth = firebase.auth()
export default firebase


// WEBPACK FOOTER //
// ./src/firebase.js